var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.componentClasses,style:(_vm.componentStyles),on:{"click":function($event){return _vm.clicked()}}},[_c('text-content',{staticClass:"gc-input-meal-category-card__text",attrs:{"weight":'extra-bold',"line-height":'multi',"size":'sm4'}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }